import { FC } from "react";
import { useAlarmColor } from "../../../../../../../../hooks/use-alarm-color";
import { ITrainControlsResponse } from "../../interfaces";
import { Box, Typography } from "@mui/material";
import { useBlinkAnimation } from "../use-blink-animation";

interface ITiAnalogDisplayProps {
  control: ITrainControlsResponse;
  flashUnacknowledgedAlarms: boolean;
  flashFaultAlarms: boolean;
}

export const TiAnalogDisplay: FC<ITiAnalogDisplayProps> = ({
  control,
  flashUnacknowledgedAlarms,
  flashFaultAlarms,
}) => {
  const { value, props, alarmStatus, unacknowledgedEvent } = control;
  const bgColor = useAlarmColor(Number(alarmStatus) || 0);

  const shouldBlinkBg = flashUnacknowledgedAlarms && unacknowledgedEvent > 0;
  const shouldBlinkBorder = flashFaultAlarms && unacknowledgedEvent === 2;

  const { animation, keyframes } = useBlinkAnimation(shouldBlinkBg, shouldBlinkBorder, bgColor);

  return (
    <Box
      sx={{
        position: "absolute",
        left: props.Left,
        top: props.Top,
        width: props.Width,
        height: props.Height,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: bgColor,
        border: "1px solid #222",

        animation,
        ...keyframes,
      }}
    >
      <Typography fontSize="12px" fontWeight="bold">
        {value}
      </Typography>
    </Box>
  );
};
